import { isEqual } from "lodash";
import { useState } from "react";

import { PeriodQuickFilter } from "./interfaces";

export const useFiscalYearCompliancePeriodQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<PeriodQuickFilter>({
    period: { periodTypes: [] },
  });

  const handleChangeQuickFilter = (filter: keyof PeriodQuickFilter, value: PeriodQuickFilter["period"]) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    fiscalYearCompliancePeriodQuickFilter: quickFilter,
    setFiscalYearCompliancePeriodQuickFilter: handleChangeQuickFilter,
  };
};
